import React from 'react';
import SupportLandingPage from "../../landing_pages/SupportLandingPage";
import NextYearClaimPage from "../NextYearClaimPage";
export function landingPagesRoutes() { return [{ path: '/support', element: /*#__PURE__*/ React.createElement(SupportLandingPage, null) }, { path: '/next_year_claim', element: /*#__PURE__*/ React.createElement(NextYearClaimPage, null) }]; }
